var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 9.6442C8.90799 9.6442 9.6442 8.90799 9.6442 7.99983C9.6442 7.09168 8.90799 6.35547 7.99983 6.35547C7.09168 6.35547 6.35547 7.09168 6.35547 7.99983C6.35547 8.90799 7.09168 9.6442 7.99983 9.6442Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 4.31216C8.90799 4.31216 9.6442 3.57596 9.6442 2.6678C9.6442 1.75964 8.90799 1.02344 7.99983 1.02344C7.09168 1.02344 6.35547 1.75964 6.35547 2.6678C6.35547 3.57596 7.09168 4.31216 7.99983 4.31216Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 14.9782C8.90799 14.9782 9.6442 14.242 9.6442 13.3338C9.6442 12.4257 8.90799 11.6895 7.99983 11.6895C7.09168 11.6895 6.35547 12.4257 6.35547 13.3338C6.35547 14.242 7.09168 14.9782 7.99983 14.9782Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVertical);
export default __webpack_public_path__ + "static/media/ellipsis-vertical.64d9edc89a61d58ba207058c440e034c.svg";
export { ForwardRef as ReactComponent };